"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypeTableNames = void 0;
var product_item_model_1 = require("./product.item.model");
Object.defineProperty(exports, "ProductTypeTableNames", { enumerable: true, get: function () { return product_item_model_1.ProductTypeTableNames; } });
//# sourceMappingURL=index.js.map